module.exports = __webpack_public_path__ + "img/tour_banner.fa9a619d.png";